<template>
  <div
    v-if="show"
    class="tip-match-share-prompt"
    @click.stop="clickMask()"
  >
    <PressPopover
      :show="show"
      :placement="`bottom`"
      :popper-class="`tip-match-share`"
      :width="`auto`"
      @click.stop="$emit('update:show', false)"
    >
      <template #default>
        <div class="tip-match-share-box">
          {{ shareText }}
        </div>
      </template>
    </PressPopover>
  </div>
</template>

<script>
import PressPopover from '@tencent/press-ui/press-popover/press-popover';
export default {
  options: {
    virtualHost: true,
  },
  components: {
    PressPopover,
  },
  props: {
  },
  data() {
    return {
      promise: '',
      resolve: '',
      reject: '',
      show: false,
      shareText: '点击“...”分享链接',
    };
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    setData(data) {
      Object.keys(data).forEach((key) => {
        try {
          this[key] = data[key];
        } catch (err) {
        }
      });
    },
    showTips(options) {
      this.show = true;

      Object.keys(options).map((key) => {
        this[key] = options[key];
      });
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
      // 返回promise对象
      return this.promise;
    },
    clickMask() {
      this.resolve();
      this.show = false;
    },
  },
};

</script>

<style lang="scss" scoped src="./css/index.scss"></style>
